module.exports = __webpack_public_path__ + "static/media/install0.315ef2b8.png";